import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DcrApprovePage } from '@/features/dcrApprove/pages/DcrApprovePage';
import { dcrApproveSearchSchema } from '@/features/dcrApprove/types/dcrApprove.types';

export const Route = createFileRoute('/_auth/billing/dcr-approve')({
  validateSearch: dcrApproveSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR Approve">
      <Suspense fallback={<PageLoader />}>
        <DcrApprovePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
